import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut, Images, Palette, HandHelping, BookOpen, Shield } from "lucide-react";

export default function Navbar() {
  const { user, login, logout } = useAuth();
  const loc = useLocation();
  const dark = loc.pathname.startsWith("/studio") || loc.pathname.startsWith("/admin");

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b ${
        dark
          ? "bg-zinc-950/70 border-white/10 text-zinc-50"
          : "bg-white/70 border-zinc-200/60 text-zinc-950"
      }`}
      data-testid="app-navbar"
    >
      <div className="px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-home-link">
          <span className="w-2 h-2 bg-lime-400 rounded-full" />
          <span className="font-serif text-2xl leading-none tracking-tight">Insta<span className="italic">Lux</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 overline">
          <Link to="/" className="hover:text-lime-500 transition-colors" data-testid="nav-manifesto">Manifesto</Link>
          {user && (
            <>
              <Link to="/studio" className="flex items-center gap-2 hover:text-lime-500 transition-colors" data-testid="nav-studio">
                <Palette className="w-3.5 h-3.5" /> Studio
              </Link>
              <Link to="/gallery" className="flex items-center gap-2 hover:text-lime-500 transition-colors" data-testid="nav-gallery">
                <Images className="w-3.5 h-3.5" /> Archive
              </Link>
              <Link to="/lookbooks" className="flex items-center gap-2 hover:text-lime-500 transition-colors" data-testid="nav-lookbooks">
                <BookOpen className="w-3.5 h-3.5" /> Books
              </Link>
              <Link to="/makers" className="flex items-center gap-2 hover:text-lime-500 transition-colors" data-testid="nav-makers">
                <HandHelping className="w-3.5 h-3.5" /> Bureau
              </Link>
              {user.is_admin && (
                <Link to="/admin" className="flex items-center gap-2 hover:text-lime-500 transition-colors" data-testid="nav-admin">
                  <Shield className="w-3.5 h-3.5" /> Admin
                </Link>
              )}
            </>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden md:flex items-center gap-2">
                {user.picture && <img src={user.picture} alt="" className="w-7 h-7 rounded-full object-cover ring-1 ring-white/20" />}
                <span className="text-sm" data-testid="nav-user-name">{user.name?.split(" ")[0]}</span>
              </div>
              <button
                onClick={logout}
                className="text-xs overline flex items-center gap-1.5 hover:text-lime-500 transition-colors"
                data-testid="nav-logout-btn"
              >
                <LogOut className="w-3 h-3" /> Sign out
              </button>
            </>
          ) : (
            <button
              onClick={login}
              className="px-5 py-2.5 rounded-full bg-lime-400 text-zinc-950 overline hover:bg-lime-300 transition-colors flex items-center gap-2"
              data-testid="nav-login-btn"
            >
              <Sparkles className="w-3.5 h-3.5" /> Enter InstaLux
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
